import React, { Fragment, useState } from "react"
import { useHistory, useLocation, } from "react-router-dom"
import { CalendarMonthRounded } from "@mui/icons-material"
import { toast } from "react-toastify"
import { ENDPOINT,  } from "../../../constants"
import { useApi } from "../../../contexts/ApiContext"
import { useAuth } from "../../../contexts/AuthContext"
import { InputField } from "../../../components/InputField"

import ImageSelector from "../../../components/ImageSelectorCourses"
import BtnGradient from '../../../components/GradientButton';
import './index.css'
import { FetchApi } from "../../../api/fetch"


const Course = () => {
   const { state }: any = useLocation();


   const [step, setStep] = useState(1)

   const [course, setCourse] = useState<any>({
      id: state.id,
      name: state.name,
      description: state.description,
      project_name: state.projectName,
      project_website: state.projectWebsite,
      number_of_ticket_award: state.numberOfTicketAward,
      max_attendees: state.maxAttendees,
      start_date: state.startDate,
      end_date: state.endDate,
      logo_url: state.logoURL,
      banner_url: state.bannerURL,
      position: state.position || 1,
      category_id: state.categoryIds,
      sub_category_id: state.subCategoryIds,
      is_featured: state.isFeatured,
      no_max_attendees: state.noMaxAttendees,
      no_expiry: state.noExpiry,
      time_required: state.timeRequired
   })




   const handleChange = async (e: any) => {
      const val = e.target.value;
      const name = e.target.name;
      const type = e.target.type;

      if (type === 'checkbox') {
         setCourse({ ...course, [name]: e.target.checked })
      } else {
         setCourse({ ...course, [name]: val })
      }
   }

   return (
      <div className="flex flex-col w-11/12 mx-auto pb-2">
         <CourseDetails
            course={course}
            step={step}
            setStep={setStep}
            handleChange={handleChange}
         />

      </div >
   )
}

export default Course

const CourseDetails = ({ course, step, setStep, handleChange }: any) => {
   const [bannerFile, setBannerFile] = useState()
   const [bannerName, setBannerName] = useState('')
   const [bannerImg, setBannerImg] = useState('')
   const [logoFile, setLogoFile] = useState()
   const [logoName, setLogoName] = useState('')
   const [logoImg, setLogoImg] = useState('')
   const { uploadFile } = useApi()
   const { getUserJWT, setIsLoadingOverlayDisplay, } = useAuth()
   const history = useHistory()

   const urlBase = "https://creator-portal-bucket.s3.us-east-2.amazonaws.com"

   const handleSubmit = async (e: any) => {
      e.preventDefault();
      setIsLoadingOverlayDisplay(true)
      const userJWT = await getUserJWT()

      if (bannerFile) {
         await uploadFile(bannerFile);
      }
      if (logoFile) {
         await uploadFile(logoFile)
      }

      try {
         const data = await FetchApi({
            endpoint: ENDPOINT.BASE_ENDPOINT_ACADEMY + `${course.id ? `/${course.id}/edit-course` : '/create-course'}`,
            method: `${course.id ? 'PATCH' : 'POST'}`,
            JWT: userJWT,
            body:  ({
               ...course,
               logo_url: `${logoName ? `${urlBase}/${logoName}` : course.logo_url}`,
               banner_url: `${bannerName ? `${urlBase}/${bannerName}` : course.banner_url}`,
               number_of_ticket_award: +course.number_of_ticket_award,
               max_attendees: +course.max_attendees,
               time_required: +course.time_required,
               start_date: course.start_date + `${(course.id && course.start_date.includes('Z')) ? '' : ':00Z'}`,
               end_date: course.end_date ? `${(course.id && course.end_date.includes('Z')) ? `${course.end_date}` : `${course.end_date}:00Z`}` : undefined
            })
         })


         if (data) {
            toast.success(data.message)
            // history.push({ pathname: `${course.name.replaceAll(' ', '-')}/lesson`, state: data.data })
            history.push({ pathname: `${data.data.ID || course.id}/lesson`, state: data.data })

         }

      } catch (error: any) {
         toast.error(error.message)
      }

      setIsLoadingOverlayDisplay(false)
      // setStep(2)
   }

   const onSelectCollectionBanner = () => {
      setTimeout(() => {
         document?.getElementById("banner_url")?.click()
      }, 0)
   }

   const handleBannerSelected = (event: any) => {
      const reader = new FileReader()
      const file = event?.target?.files && event?.target?.files[0]
      if (file) {
         setBannerFile(file)
         reader.onloadend = () => {
            setBannerImg(reader?.result as string)
            setBannerName(`${file.name}`)

            // setCollectionBannerName(`${BANNER_FILE_NAME}.${extension(file.type)}`)
         }
         reader.readAsDataURL(file as Blob)
      }
   }
   const onSelectCollectionThumbnail = () => {
      setTimeout(() => {
         document?.getElementById("logo_url")?.click()
      }, 0)
   }

   const handleCollectionThumbnailSelected = (event: any) => {
      const reader = new FileReader()
      const file = event?.target?.files && event?.target?.files[0]
      if (file) {
         setLogoFile(file)
         reader.onloadend = () => {
            setLogoImg(reader?.result as string)
            setLogoName(
               `${file.name}`
               //    // `${THUMBNAIL_FILE_NAME}.${extension(file.type)}`
            )
         }
         reader.readAsDataURL(file as Blob)
      }
   }
   return (
      <div >
         <form
            onSubmit={handleSubmit}
            className="w-full mb-48"
         >
            <div className="mt-8 flex flex-row mb-4 justify-between items-center sm:flex-row">
               <div className="mb-4 sm:mb-0">
                  <h1 className="font-semibold text-3xl text-left">
                     Create a new course

                  </h1>
               </div>

            </div>


            <Fragment>
               <div className="mb-4">
                  <InputField
                     onChange={handleChange}
                     value={course.name}
                     required
                     className="w-full"
                     name="name"
                     label="Course Name"
                     placeholder="Enter course name"
                  />
               </div>
               <div className="flex justify-start mb-4  w-36">
                  <div className="w-8">
                     <InputField
                        onChange={handleChange}
                        type="checkbox"
                        checked={course.is_featured}
                        name="is_featured"
                        className="form-tick h-4 w-4 border-2 border-black disabled:border-gray-300 rounded-md checked:bg-blue-600 checked:border-transparent focus:outline-none mr-3 cursor-pointer"
                     />
                  </div>
                  <label className="text-sm text-left text-gray-40 w-full ml-2">Featured</label>
               </div>
               <div className="mb-4">
                  <label className="inline-block text-sm font-base text-gray-40 mb-2 w-5/6 mr-0">
                     Course Description
                  </label>
                  <textarea
                     rows={3} id=""
                     className="block bg-transparent border-2 p-4 border-kyzzen-secondary text-gray-40 placeholder-gray-600 rounded-lg w-full"
                     name='description'
                     value={course?.description}
                     onChange={handleChange}
                     placeholder="Enter course description"
                     required
                  />
               </div>
               <div className="mb-4">
                  <InputField
                     onChange={handleChange}
                     value={course.project_name}
                     required
                     className="w-full"
                     name="project_name"
                     label="Project Name"
                     placeholder="Enter project name"
                  />
               </div>
               <div className="mb-4">
                  <InputField
                     onChange={handleChange}
                     value={course.project_website}
                     required
                     className="w-full"
                     name="project_website"
                     label="Project Website "
                     placeholder="Enter project website url"
                  />
               </div>
               <div className="mb-4">
                  <InputField
                     onChange={handleChange}
                     value={course.time_required}
                     // required
                     type="number"
                     className="w-full"
                     name="time_required"
                     label="Time Required"
                     placeholder="Enter the number of minutes required to finish course"
                  />
               </div>
               <div className="mb-4">
                  <InputField
                     onChange={handleChange}
                     value={course.number_of_ticket_award}
                     required
                     type="number"
                     className="w-full"
                     name="number_of_ticket_award"
                     label="No. of Ticket Awarded"
                     placeholder="Enter the number of tickets to be rewarded upon successful completion of the course"
                  />
               </div>
               <div className="mb-2">
                  <InputField
                     type="number"
                     onChange={handleChange}
                     value={course.no_max_attendees ? '' : course.max_attendees}
                     required={!course.no_max_attendees}
                     className="w-full"
                     name="max_attendees"
                     label="Maximum No. of Attendees"
                     placeholder="Enter the maximum number of attendees that can take this course"
                     readOnly={course.no_max_attendees}
                  />

               </div>
               <div className="flex justify-start mb-4  w-36">
                  <div className="w-8">
                     <InputField
                        onChange={handleChange}
                        type="checkbox"
                        checked={course.no_max_attendees}
                        name="no_max_attendees"
                        className="form-tick h-4 w-4 border-2 border-black disabled:border-gray-300 rounded-md checked:bg-blue-600 checked:border-transparent focus:outline-none mr-3 cursor-pointer"
                     />
                  </div>
                  <label className="text-sm text-left text-gray-40 w-full ml-2">No Maximum</label>
               </div>
               <div>
                  <label className="inline-block text-sm font-base text-gray-40 mb-2 w-5/6 mr-0">
                     Date Range
                  </label>
                  <div className='grid grid-cols-2 gap-4 items-start'>
                     <div className='flex items-center gap-2'>
                        <label className="inline-block text-sm font-base text-gray-40 mb-2 font-extralight mr-0">
                           Start
                        </label>
                        <InputField
                           type='datetime-local'
                           onChange={handleChange}
                           value={course.start_date?.slice(0, 16)}
                           required
                           className="w-full d"
                           name="start_date"
                        />
                        <span className='w-fit bg-accent-green p-1 pb-1.5 rounded-xl mb-4'>
                           <CalendarMonthRounded className='text-kyzzen-primary w-8 h-8' />
                        </span>
                     </div>
                     <div>
                        <div className='flex items-center gap-2'>
                           <label className="inline-block text-sm font-base text-gray-40 font-extralight mb-2  mr-0">
                              End
                           </label>
                           <InputField
                              type='datetime-local'
                              onChange={handleChange}
                              value={course.no_expiry ? '' : course.end_date?.slice(0, 16)}
                              required={!course.no_expiry}
                              className="w-full d"
                              name="end_date"
                              readOnly={course.no_expiry}
                           />
                           <span className='w-fit bg-accent-green p-1 pb-1.5 rounded-xl mb-4'>
                              <CalendarMonthRounded className='text-kyzzen-primary w-8 h-8' />
                           </span>
                        </div>
                        <div className="flex justify-start mb-4  w-36">
                           <div className="w-8">
                              <InputField
                                 onChange={handleChange}
                                 type="checkbox"
                                 checked={course.no_expiry}
                                 name="no_expiry"
                                 className="form-tick h-4 w-4 border-2 border-black disabled:border-gray-300 rounded-md checked:bg-blue-600 checked:border-transparent focus:outline-none mr-3 cursor-pointer"
                              />
                           </div>
                           <label className="text-sm text-left text-gray-40 w-full ml-2">No Expiry</label>
                        </div>
                     </div>

                  </div>
               </div>
               <div className="w-full mx-auto mb-8 mt-8">
                  <input
                     style={{ display: "none" }}
                     type="file"
                     accept=".png, .jpg, .jpeg, .gif"
                     id="banner_url"
                     name="banner_url"
                     onChange={handleBannerSelected}
                  />
                  <input
                     style={{ display: "none" }}
                     type="file"
                     accept=".png, .jpg, .jpeg, .gif"
                     id="logo_url"
                     onChange={handleCollectionThumbnailSelected}
                  />
                  <ImageSelector
                     imageSrc={course.banner_url && !bannerImg ? course.banner_url : bannerImg}
                     iconSrc={course.logo_url && !logoImg ? course.logo_url : logoImg}
                     onSelectImage={onSelectCollectionBanner}
                     onSelectIcon={onSelectCollectionThumbnail}
                  />
               </div>
            </Fragment>

            <BtnGradient>
               <button type="submit" className="btn bg-gradient text-kyzzen-primary w-full" id="sub">Continue</button>
            </BtnGradient>

         </form>


      </div>
   )
}


